import React, { useEffect, useState } from 'react';
import customFetch from '../utils/customFetch';
import { redirect, useLoaderData, useNavigate } from 'react-router-dom';
import {
  Banner,
  Logo,
  ProfileDownloader,
  PublicLinkItem,
  QrCodePopup,
} from '../components';
import { hintergruende } from '../utils/hintergruende';
import { Helmet } from 'react-helmet';
import EmptyLinks from '../components/linksPublic/emptyLinks';
import BlockedPage from '../components/linksPublic/blockedPage';
import { QrCodeIcon } from '@heroicons/react/20/solid';
import { buildCloudinaryUrl } from '../utils/buildCloudinaryUrl';

export const loader = async ({ params }) => {
  try {
    const { data } = await customFetch.get(`/public/links/${params.id}`);
    return data;
  } catch (error) {
    return redirect('/');
  }
};

const CardPage = () => {
  const data = useLoaderData();
  console.log(data);
  // Wenn noch keine Settings gespeichert wurden, werden hier defaults festgelegt
  if (!data.linkSettings) {
    data.linkSettings = {
      backgroundContent: 'Topografie',
      backgroundType: 'Muster',
      iconColor: '#2a2a2a',
      linkColor: '#2a2a2a',
    };
  }
  const background = hintergruende.find(
    (item) => item.title === data.linkSettings.backgroundContent
  );

  // QR Code Popup State
  const [openQrPopup, setOpenQrPopup] = useState(false);

  // Wenn Nutzer in localStorage gleich dem Seiteninhaber, zeige Seite an. Sonst redirect
  const userObject = localStorage.getItem('user');
  const user = userObject ? JSON.parse(userObject) : { url: 'test' };
  const navigate = useNavigate();
  useEffect(() => {
    if (user && data.user.status === 'pending' && data.user.url !== user.url) {
      navigate('/404');
    }
  }, []);

  const optimizedAvatar = buildCloudinaryUrl(data.user.avatarPublicId || "Default_user_pic_ncdhdy", 'w_400');
  const optimizedHeader = buildCloudinaryUrl(
    data.linkSettings.headerContentPublicId || "background_c4jgy3.jpg",
    'w_1200'
  );

  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex,nofollow" />
      </Helmet>

      {/* Hier Unterscheidung, ob Profil blockiert */}

      {data.user.status === 'blocked' ? (
        <BlockedPage />
      ) : (
        <>
          <div
            style={
              data.linkSettings.backgroundType === 'Muster'
                ? {
                    backgroundImage: background.backgroundImage,
                  }
                : data.linkSettings.backgroundType === 'Farbe'
                ? {
                    backgroundColor: data.linkSettings.backgroundContent,
                  }
                : {}
            }
            className="fixed  top-0 w-full h-full -z-10"
          ></div>

          {/* Pending Page Logik Start */}

          {data.user.status === 'pending' && data.user.url === user.url ? (
            <Banner
              header="Achtung, diese Seite ist nur eine Vorschau"
              content="Deine Seite ist erst öffentlich zugänglich, wenn du deine erste sVisit-Karte gekauft hast und deine Bestellung bearbeitet wurde."
              link="/produkte"
            />
          ) : (
            ''
          )}

          {/* Pending Page Logik Ende */}

          {/* Full Page QR Code Popup Start */}
          <QrCodePopup
            openQrPopup={openQrPopup}
            setOpenQrPopup={setOpenQrPopup}
            url={data.user.url}
          />
          {/* Full Page QR Code Popup Ende */}

          <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
            <div className="mx-auto max-w-3xl">
              {/* Header und Profilbild Start */}
              <div className="block w-full mt-10">
                {data.linkSettings.showHeader ? (
                  <>
                    <div className="aspect-w-2 aspect-h-1 rounded-lg overflow-hidden shadow-2xl">
                      <img
                        src={optimizedHeader}
                        alt="header"
                        className="object-cover"
                      />
                    </div>
                    <img
                      className="sm:h-80 sm:w-80 h-52 w-52 rounded-full mx-auto shadow-2xl object-cover sm:-mt-40 -mt-24 relative"
                      src={optimizedAvatar}
                      alt="avatar"
                    />
                  </>
                ) : (
                  <img
                    className="sm:h-80 sm:w-80 h-60 w-60 rounded-full mx-auto shadow-2xl object-cover"
                    src={optimizedAvatar}
                    alt="avatar"
                  />
                )}
              </div>
              {/* Header und Profilbild Ende */}
              {/* Name und Titel des Nutzers Start */}
              <div
                className="text-center mt-10"
                style={{ color: data.linkSettings.linkColor }}
              >
                <h1 className="capitalize text-3xl font-semibold sm:text-4xl">{`${data.user.firstName} ${data.user.lastName}`}</h1>
                <h2 className="mt-4 text-xl font-semibold sm:text-2xl">
                  {`${data.user.title ? data.user.title : ''}${
                    data.user.title && data.user.company ? ' bei ' : ''
                  }${data.user.company ? data.user.company : ''}`}
                </h2>
              </div>
              {/* Name und Titel des Nutzers Ende */}
              {/* Profil Download und QR-Code Start */}
              <div className="mt-4 mb-10 flex justify-center gap-5">
                {/* Profile Downloader alle Angaben zum Nutzer übergeben, damit VCard erstellt werden kann*/}
                <ProfileDownloader
                  textColor={data.linkSettings.linkColor}
                  user={data.user}
                  optimizedAvatar={optimizedAvatar}
                  links={data.links}
                />
                <button
                  type="button"
                  className="rounded-md bg-white px-3.5 py-2.5 text-lg font-semibold focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 shadow-lg hover:shadow-sm transition-all"
                  style={{ color: data.linkSettings.linkColor }}
                  onClick={() => setOpenQrPopup(true)}
                >
                  <QrCodeIcon className="-mr-0.5 h-5 w-5" aria-hidden="true" />
                </button>
              </div>
              {/* Profil Download und QR-Code Ende */}
              <ul className="w-[100%]">
                {Object.keys(data.links).length > 0 ? (
                  data.links.map((link) => (
                    <PublicLinkItem
                      {...link}
                      key={link._id}
                      linkColor={data.linkSettings.linkColor}
                      iconColor={data.linkSettings.iconColor}
                    />
                  ))
                ) : (
                  <EmptyLinks />
                )}
              </ul>
            </div>
          </div>
          <footer>
            <div className="mx-auto max-w-7xl overflow-hidden px-6 pt-20 pb-5 sm:pt-24 lg:px-8">
              <nav
                className="-mb-6 columns-2 flex justify-center space-x-12"
                aria-label="Footer"
              >
                <div className="pb-6">
                  <a
                    href="/login"
                    className="text-sm leading-6 text-gray-600 hover:text-gray-900"
                  >
                    Anmelden
                  </a>
                </div>
                <div className="pb-6">
                  <a
                    href="/register"
                    className="text-sm leading-6 text-gray-600 hover:text-gray-900"
                  >
                    Registrieren
                  </a>
                </div>
              </nav>
              <div className="mt-10 justify-center">
                <a href="/" target="_blank">
                  <Logo />
                  <h3 className="text-center text-sm font-semibold leading-6 text-gray-900 mt-4">
                    sVisit
                  </h3>
                </a>
              </div>
              <p className="mt-10 text-center text-xs leading-5 text-gray-500">
                &copy; {new Date().getFullYear()} sVisit.
              </p>
            </div>
          </footer>
        </>
      )}
    </>
  );
};

export default CardPage;
